"use strict";

var _interopRequireDefault = require("E:/dianlala_project/\u7535\u5566\u5566/cd-vue-admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("E:/dianlala_project/\u7535\u5566\u5566/cd-vue-admin/node_modules/@babel/runtime/helpers/defineProperty.js"));
require("core-js/modules/es6.object.keys");
require("core-js/modules/es6.array.sort");
require("core-js/modules/es6.regexp.to-string");
require("core-js/modules/es6.function.name");
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es7.object.values");
var _index = require("@/utils/index");
var _upload = _interopRequireDefault(require("@/components/upload"));
var _Tinymce = _interopRequireDefault(require("@/components/Tinymce"));
var _map = _interopRequireDefault(require("@/components/map"));
var _area = _interopRequireDefault(require("@/components/area.json"));
var _percent = _interopRequireDefault(require("./_percent"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'ShopCreate',
  components: {
    upload: _upload.default,
    maps: _map.default,
    Tinymce: _Tinymce.default,
    percent: _percent.default
  },
  data: function data() {
    return {
      clickSubmit: false,
      categoryList: [],
      areaList: [],
      wash_type: 0,
      merchantTags: [{
        label: '1688',
        value: '1688'
      }, {
        label: '拼多多',
        value: '拼多多'
      }, {
        label: '淘宝',
        value: '淘宝'
      }, {
        label: '线下',
        value: '线下'
      }],
      form: {
        agent_withdraw_fee_type: 0,
        cat_id: [],
        region_tag: [],
        avatar: '',
        password: '666888999',
        withdraw_percent: 0,
        withdraw_fee: 0,
        longitude: '',
        check_order: 0,
        withdraw_right: 0,
        divide_type_1: 0,
        deposit_is_backtrack: 0,
        merchant_tag: '线下',
        // 充电宝
        bao_fee_plan: {
          rent_fee_std: 2,
          rent_unit_minute_std: 60,
          day_most_std: 15,
          deposit_amount_std: 99
        },
        zhuang_fee_plan: {},
        zhuang_electrcity_plan: {},
        wash_laundry_fee_plan: []
      },
      rules: {
        store_name: [{
          required: true,
          message: '请填写商户名称',
          trigger: 'blur'
        }],
        mobile: [{
          required: true,
          message: '请填写商家电话',
          trigger: 'blur'
        }],
        address: [{
          required: true,
          message: '请填写商家地址',
          trigger: 'blur'
        }],
        name: [{
          required: true,
          message: '请填写联系人姓名',
          trigger: 'blur'
        }],
        phone: [{
          required: true,
          message: '请填写手机号码作为登录账户',
          trigger: 'blur'
        }],
        cat_id: [{
          required: true,
          message: '请选择行业分类',
          trigger: 'blur'
        }],
        region_tag: [{
          required: true,
          message: '请选择城市区域',
          trigger: 'blur'
        }],
        longitude: [{
          required: true,
          message: '请选择地图定位'
        }],
        merchant_tag: [{
          required: true,
          message: '请选择商户标签',
          trigger: 'change'
        }]
      },
      // 提现手续费
      withdrawFeeObj: {},
      powerInfo: {},
      fileList: [],
      id: this.$route.params.id || '',
      fid: this.$route.query.fid || '',
      divide_type_1: this.$route.query.divide_type || 0,
      agentDevice: [],
      selType: []
    };
  },
  computed: {
    deviceNameObj: function deviceNameObj() {
      return this.$store.getters.deviceNameObj;
    },
    siteInfo: function siteInfo() {
      var siteInfo = this.$store.getters.siteInfo;
      this.form.agent_withdraw_fee_type = siteInfo.merchant_withdraw_fee_type;
      return this.$store.getters.siteInfo;
    }
  },
  mounted: function mounted() {
    this.getDefaultConfig();
    if (this.id > 0) {} else {
      this.getDeviceType();
      this.getCategory();
      this.getArea();
      this.form.divide_type_1 = this.divide_type_1;
      this.form.deposit_is_backtrack = this.deposit_is_backtrack;
      this.form.bao_fee_plan.deposit_amount_std = this.siteInfo.limit_deposit_amount_max;
    }
    this.getPower();
  },
  methods: {
    /**
     * 获取信息
     */
    getDefaultConfig: function getDefaultConfig() {
      var _this = this;
      this.$get('agentapi/get_partner_config', {}).then(function (res) {
        var fee_plan = {},
          goods_key = _this.config.goods_key,
          fee_xcx = _this.config.fee_xcx;
        for (var i in goods_key) {
          var goods_key_fee = fee_xcx[goods_key[i]] || fee_xcx.default;
          for (var key in goods_key_fee) {
            if (res["".concat(goods_key[i], "_fund_fee_plan").concat(key)]) {
              fee_plan["".concat(goods_key[i], "_fund_fee_plan").concat(key)] = res["".concat(goods_key[i], "_fund_fee_plan").concat(key)];
            }
            if (res["".concat(goods_key[i], "_fee_plan").concat(key)]) {
              fee_plan["".concat(goods_key[i], "_fee_plan").concat(key)] = res["".concat(goods_key[i], "_fee_plan").concat(key)];
            }
            if (res["zhen_fee_plan".concat(key)]) {
              fee_plan["zhen_fee_plan".concat(key)] = res["zhen_fee_plan".concat(key)];
            }
          }
        }
        if (_this.id > 0) {
          _this.getInfo(fee_plan);
        } else {
          fee_plan.business_mode = res.business_mode;
          var zhuang_hourfeeplan = [];
          for (var _i in res.zhuang_hour_fee_plan.plan) {
            if (_i < 4) {
              zhuang_hourfeeplan.push(res.zhuang_hour_fee_plan.plan[_i]);
            }
          }
          fee_plan.zhuang_hourfeeplan = zhuang_hourfeeplan;
          var zhuang_minfeeplan = [];
          for (var _i2 in res.zhuang_min_fee_plan.plan) {
            if (_i2 < 4) {
              zhuang_minfeeplan.push(res.zhuang_min_fee_plan.plan[_i2]);
            }
          }
          fee_plan.zhuang_minfeeplan = zhuang_minfeeplan;
          if (fee_plan.zhuang_fee_plan) {
            delete fee_plan.zhuang_fee_plan.plan[5];
            delete fee_plan.zhuang_fee_plan.plan[6];
            delete fee_plan.zhuang_fee_plan.plan[7];
            delete fee_plan.zhuang_fee_plan.plan[8];
            delete fee_plan.zhuang_fee_plan.plan[9];
            delete fee_plan.zhuang_fee_plan.plan[10];
            Object.values(fee_plan.zhuang_fee_plan.plan).map(function (item) {
              var n = parseInt(item.value) + 1;
              return item.rent_zhuang_unit_power_max = fee_plan.zhuang_fee_plan.plan[n] ? parseInt(fee_plan.zhuang_fee_plan.plan[n].rent_zhuang_unit_power_min) - 1 : _this.config.zhuang_power_max;
            });
            fee_plan.zhuang_electrcity_plan = fee_plan.zhuang_fee_plan;
          }
          if (res.wash_laundry_fee_plan) fee_plan.wash_laundry_fee_plan = res.wash_laundry_fee_plan;
          _this.form = Object.assign({}, _this.form, fee_plan);
        }
      });
    },
    /**
     * 获取权限
     */
    getPower: function getPower() {
      var _this2 = this;
      this.$get('agentapi/add_merchant').then(function (res) {
        res.bao_percent = res.percent;
        _this2.powerInfo = res;
      });
    },
    /**
     * 获取设备
     */
    getDeviceType: function getDeviceType() {
      var _this3 = this;
      var id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      this.$get('agentapi/sttuf/son_device_type', {
        son_id: id
      }).then(function (res) {
        var selType = [];
        for (var i in res) {
          if (_this3.id) {
            if (res[i].son_taked > 0) {
              selType.push(res[i].depend_type);
            }
          } else if (res[i].taked > 0) {
            selType.push(res[i].depend_type);
          }
        }
        _this3.selType = JSON.parse(JSON.stringify(selType));
        _this3.agentDevice = res;
      });
    },
    /**
     * 获取商户类别
     */
    getCategory: function getCategory() {
      var _this4 = this;
      this.$get('agentapi/store/store_cat_list').then(function (res) {
        for (var i in res) {
          var obj = {
            value: res[i].cat_id,
            label: res[i].cat_name,
            children: []
          };
          if (_this4.cat_id == obj.value) {
            if (res[i].son_cat_list.length > 0) {
              _this4.form.cat_id = [obj.value, res[i].son_cat_list[0].cat_id];
            } else {
              _this4.form.cat_id = [obj.value];
            }
          }
          if (res[i].son_cat_list.length > 0) {
            for (var s in res[i].son_cat_list) {
              var child = res[i].son_cat_list[s];
              if (_this4.cat_id == child.cat_id) _this4.form.cat_id = [obj.value, child.cat_id];
              obj.children.push({
                value: child.cat_id,
                label: child.cat_name
              });
            }
          } else {
            obj.children = undefined;
          }
          _this4.categoryList.push(obj);
        }
        if (!_this4.id) {
          var first = _this4.categoryList[0];
          _this4.form.cat_id = [first.value, first.children.length > 0 ? first.children[0].value : ''];
        }
      });
    },
    /**
     * 获取区域
     */
    getArea: function getArea() {
      var res = _area.default;
      for (var i in res) {
        var firstLevel = res[i];
        var obj = {
          value: firstLevel.tag,
          label: firstLevel.title,
          children: []
        };
        if (firstLevel.son_list.length > 0) {
          var secondLevel = firstLevel.son_list;
          for (var s in secondLevel) {
            var secondItem = secondLevel[s];
            if (this.region_tag == secondItem.tag) this.form.region_tag = [obj.value, secondItem.tag];
            obj.children.push({
              value: secondItem.tag,
              label: secondItem.title,
              children: []
            });
            if (secondItem.son_list.length > 0) {
              var thirdLevel = secondItem.son_list;
              for (var t in thirdLevel) {
                var thirdItem = thirdLevel[t];
                if (this.region_tag == thirdItem.tag) this.form.region_tag = [obj.value, secondItem.tag, thirdItem.tag];
                obj.children[s].children.push({
                  value: thirdItem.tag,
                  label: thirdItem.title
                });
              }
            } else {
              obj.children = undefined;
            }
          }
        } else {
          obj.children = undefined;
        }
        this.areaList.push(obj);
      }
      if (!this.id) {
        var first = this.areaList[0];
        this.form.region_tag = [first.value, first.children[0].value, first.children[0].children[0].value];
      }
    },
    /**
     * 获取商户信息
     */
    getInfo: function getInfo(fee_plan) {
      var _this5 = this;
      this.$get('agentapi/my_merchant_detail_old', {
        store_id: this.id
      }).then(function (res) {
        var info = {
          son_id: res.son_id,
          store_id: res.store_id,
          is_major: res.is_major,
          avatar: res.store_info.avatar,
          store_name: res.store_info.name,
          mobile: res.store_info.mobile,
          address: res.store_info.address,
          lat: res.store_info.lat,
          lng: res.store_info.lng,
          longitude: res.store_info.lng,
          introduce: res.store_info.introduce,
          divide_type_1: res.store_info.divide_type_1,
          deposit_is_backtrack: res.store_info.deposit_is_backtrack,
          advance_buletooth: res.store_info.advance_buletooth,
          skipzfb: res.store_info.skipzfb,
          name: res.profit_info.contact,
          user_name: res.user_name,
          business_mode: res.business_mode,
          wash_laundry_fee_plan: res.wash_laundry_fee_plan || [],
          zhuang_electrcity_plan: res.zhuang_electrcity_plan || [],
          merchant_tag: res.store_info.merchant_tag || '线下' // 单选值处理
        };
        if (info.lng > 0 && info.lat > 0) {
          var lng_lat = (0, _index.qqMapTransBMap)(info.lng, info.lat);
          info.lng = lng_lat.lng;
          info.lat = lng_lat.lat;
        }
        var goods_key = _this5.config.goods_key,
          fee_xcx = _this5.config.fee_xcx;
        for (var i in goods_key) {
          var goods_key_fee = fee_xcx[goods_key[i]] || fee_xcx.default;
          for (var key in goods_key_fee) {
            if (res["".concat(goods_key[i], "_fund_fee_plan").concat(key)]) {
              info["".concat(goods_key[i], "_fund_fee_plan").concat(key)] = res["".concat(goods_key[i], "_fund_fee_plan").concat(key)];
            }
            if (res["".concat(goods_key[i], "_fee_plan").concat(key)]) {
              info["".concat(goods_key[i], "_fee_plan").concat(key)] = res["".concat(goods_key[i], "_fee_plan").concat(key)];
            }
          }
        }
        info.zhuang_hour_fee_plan = res.zhuang_hour_fee_plan;
        var zhuang_hourfeeplan = [];
        if (info.zhuang_hour_fee_plan) {
          for (var _i3 in res.zhuang_hour_fee_plan.plan) {
            zhuang_hourfeeplan.push(res.zhuang_hour_fee_plan.plan[_i3]);
          }
        }
        info.zhuang_hourfeeplan = zhuang_hourfeeplan;
        info.zhuang_min_fee_plan = res.zhuang_min_fee_plan;
        var zhuang_minfeeplan = [];
        if (info.zhuang_min_fee_plan) {
          for (var _i4 in res.zhuang_min_fee_plan.plan) {
            zhuang_minfeeplan.push(res.zhuang_min_fee_plan.plan[_i4]);
          }
        }
        info.zhuang_minfeeplan = zhuang_minfeeplan;
        var zhuang_power_max = res.store_info.zhuang_power_max;
        if (!zhuang_power_max) {
          zhuang_power_max = _this5.config.zhuang_power_max;
          if (res.store_info.zhuang_high_power == 1) {
            zhuang_power_max = 3500;
          }
        }
        info.zhuang_high_power = res.store_info.zhuang_high_power || 0;
        if (info.zhuang_fee_plan) {
          Object.values(info.zhuang_fee_plan.plan).map(function (item) {
            var n = parseInt(item.value) + 1;
            return item.rent_zhuang_unit_power_max = info.zhuang_fee_plan.plan[n] ? parseInt(info.zhuang_fee_plan.plan[n].rent_zhuang_unit_power_min) - 1 : zhuang_power_max;
          });
        }
        if (info.zhuang_electrcity_plan) {
          Object.values(info.zhuang_electrcity_plan.plan).map(function (item) {
            var n = parseInt(item.value) + 1;
            return item.rent_zhuang_unit_power_max = info.zhuang_electrcity_plan.plan[n] ? parseInt(info.zhuang_electrcity_plan.plan[n].rent_zhuang_unit_power_min) - 1 : zhuang_power_max;
          });
        }
        _this5.fileList = [{
          url: res.store_info.avatar
        }];
        info = Object.assign(fee_plan, info, res.profit_info);
        if (_this5.siteInfo.merchant_withdraw_fee_type != 2) info.agent_withdraw_fee_type = _this5.siteInfo.agent_withdraw_fee_type;
        if (_this5.checkRoles(['partner'])) {
          _this5.$get('agentapi/getAdminWithdrawConfig', {
            admin_id: res.son_id
          }).then(function (res) {
            _this5.withdrawFeeObj = res;
          });
        }
        _this5.form = info;
        _this5.cat_id = res.store_info.cat_id;
        _this5.region_tag = res.store_info.region_tag;
        _this5.getDeviceType(res.son_id);
        _this5.getCategory();
        _this5.getArea();
      });
    },
    onSubmit: function onSubmit(formName) {
      var _this6 = this;
      var url = 'agentapi/add_store';
      this.clickSubmit = true;
      this.$refs[formName].validate(function (valid, object) {
        if (valid) {
          var params = JSON.parse(JSON.stringify(_this6.form));
          params.cat_id = _this6.form.cat_id[1] ? _this6.form.cat_id[1] : _this6.form.cat_id[0];
          params.region_tag = _this6.form.region_tag[2];
          // 添加商户标签参数
          params.merchant_tag = _this6.form.merchant_tag;
          if (params.latitude > 0 && params.longitude > 0) {
            var lng_lat = (0, _index.bMapTransQQMap)(params.longitude, params.latitude);
            params.longitude = lng_lat.lng;
            params.latitude = lng_lat.lat;
          }
          if (_this6.fid) {
            url = 'agentapi/store/fen_dian_add';
            params.son_id = _this6.fid;
          } else if (params.is_major == 0) {
            url = 'agentapi/store/fen_dian_edit';
          } else if (_this6.id > 0) {
            url = 'agentapi/edit_store';
          }
          params.user_name = params.phone;
          for (var i in _this6.selType) {
            params['depend_type_' + _this6.selType[i]] = 1;
          }
          if (_this6.update_fee_error && _this6.add_store_id && _this6.add_son_id) {
            _this6.update_fee_plane(_this6.add_store_id, _this6.add_son_id);
            return;
          }
          var isEditStore = url === 'agentapi/edit_store' || url === 'agentapi/store/fen_dian_edit';
          // 【操作埋点】2026-05-25 新增/编辑商户 pc_shop_add_1 / pc_shop_edit_1
          var shopReportMeta = isEditStore ? _this6.$buildAdminOperationReportMeta({
            operation_option: '编辑商户',
            content: "\u7F16\u8F91\u5546\u6237\u300C".concat(params.store_name || '', "\u300D\uFF0C\u8054\u7CFB\u4EBA ").concat(params.name || '', "\uFF0C\u624B\u673A\u53F7 ").concat(params.phone || '', "\uFF0C\u5730\u5740 ").concat(params.address || ''),
            operation_id: 'pc_shop_edit_1'
          }) : _this6.$buildAdminOperationReportMeta({
            operation_option: '添加商户',
            content: "\u65B0\u589E\u5546\u6237\u300C".concat(params.store_name || '', "\u300D\uFF0C\u8054\u7CFB\u4EBA ").concat(params.name || '', "\uFF0C\u624B\u673A\u53F7 ").concat(params.phone || '', "\uFF0C\u5730\u5740 ").concat(params.address || ''),
            operation_id: 'pc_shop_add_1'
          });
          _this6.$post(url, params, shopReportMeta).then(function (res) {
            _this6.add_store_id = res.store_id;
            if (_this6.id > 0) {
              _this6.add_son_id = _this6.form.son_id;
            } else {
              _this6.add_son_id = res.son_id;
              if (_this6.checkRoles(['partner'])) {
                _this6.$get('agentapi/getAdminWithdrawConfig', {
                  admin_id: res.son_id
                }).then(function (resdata) {
                  //this.withdrawFeeObj = resdata
                  _this6.withdrawFeeObj.admin_id = _this6.add_son_id;
                });
              }
            }
            _this6.update_fee_plane(res.store_id);
          }).catch(function (err) {
            setTimeout(function () {
              _this6.clickSubmit = false;
            }, 1000);
          });
        } else {
          _this6.formErrow(object);
          _this6.clickSubmit = false;
        }
      });
    },
    update_fee_plane: function update_fee_plane(id) {
      var _this7 = this;
      var params = {},
        form = this.form,
        goods_key = this.config.goods_key,
        fee_xcx = this.config.fee_xcx,
        url = 'agentapi/store/update_fee_plane';
      console.log(form);
      for (var s in this.selType) {
        var si = this.selType[s];
        if (si == 0) {
          params = Object.assign({}, params, form.bao_fee_plan);
        } else if (si == 2) {
          var list = form.zhen_fee_plan;
          for (var i in list) {
            var plan = list[i];
            params["rent_major_title_".concat(plan.value)] = plan.rent_major_title;
            params["rent_is_show_".concat(plan.value)] = plan.rent_is_show;
            params["rent_major_fee_".concat(plan.value)] = plan.rent_major_fee;
            params["rent_major_unit_".concat(plan.value)] = plan.rent_major_unit;
            params["rent_attach_unit_".concat(plan.value)] = plan.rent_attach_unit;
          }
        } else if (si == 1) {
          //const list = form.thread_fee_plan
          // for (var i in list) {
          //   const plan = list[i]
          //   params[`rent_unit_hour_${plan.value}`] = plan.rent_unit_hour
          //   params[`rent_unit_fee_${plan.value}`] = plan.rent_unit_fee
          //   params[`rent_unit_show_${plan.value}`] = plan.rent_unit_show
          // }
        } else if (si == 3) {
          if (form.business_mode.std_zhuang.business_mode_type == 2) {
            params = Object.assign({}, params, form.zhuang_electrcity_plan);
          } else if (form.business_mode.std_zhuang.business_mode_type == 1) {
            params = Object.assign({}, params, form.zhuang_fee_plan);
          } else if (form.business_mode.std_zhuang.business_mode_type == 3) {
            var _list = form.zhuang_minfeeplan;
            for (var i in _list) {
              var _plan = _list[i];
              params["rent_zhuang_unit_min_".concat(_plan.value)] = _plan.rent_zhuang_unit_min.toString();
              params["rent_zhuang_unit_fee_".concat(_plan.value)] = _plan.rent_zhuang_unit_fee;
              params["rent_zhuang_unit_show_".concat(_plan.value)] = _plan.rent_zhuang_unit_show.toString();
            }
            params.zhuang_minfeeplan_length = _list.length;
          } else {
            var _list2 = form.zhuang_hourfeeplan;
            for (var i in _list2) {
              var _plan2 = _list2[i];
              params["rent_zhuang_unit_hour_".concat(_plan2.value)] = _plan2.rent_zhuang_unit_hour.toString();
              params["rent_zhuang_unit_fee_".concat(_plan2.value)] = _plan2.rent_zhuang_unit_fee;
              params["rent_zhuang_unit_show_".concat(_plan2.value)] = _plan2.rent_zhuang_unit_show.toString();
            }
            params.zhuang_hourfeeplan_length = _list2.length;
          }
          for (var i in params.plan) {
            var _plan3 = params.plan[i];
            params["rent_zhuang_unit_fee_".concat(_plan3.value)] = _plan3.rent_zhuang_unit_fee;
            params["rent_zhuang_unit_power_min_".concat(_plan3.value)] = _plan3.rent_zhuang_unit_power_min;
          }
          params.zhuang_powerfeeplan_length = Object.values(form.zhuang_electrcity_plan.plan).length;
          params.zhuang_service_powerfeeplan_length = Object.values(form.zhuang_electrcity_plan.plan).length;
          params.rent_zhuang_electrcity_fee = form.zhuang_electrcity_plan.rent_zhuang_electrcity_fee;
          params.rent_zhuang_service_fee = form.zhuang_electrcity_plan.rent_zhuang_service_fee;
          params.rent_zhuang_service_mode = form.zhuang_electrcity_plan.rent_zhuang_service_mode;
        } else if (si == 4) {
          var _list3 = form.wash_fee_plan,
            wash_laundy = form.wash_laundry_fee_plan;
          for (var i in _list3) {
            var _plan4 = _list3[i];
            params["rent_wash_unit_show_".concat(_plan4.value)] = _plan4.is_show;
            params["rent_wash_unit_fee_".concat(_plan4.value)] = _plan4.money;
          }
          for (var i in wash_laundy) {
            var laundy = wash_laundy[i];
            params["rent_laundry_unit_show_".concat(laundy.value)] = laundy.is_show;
            params["rent_laundry_unit_fee_".concat(laundy.value)] = laundy.money;
          }
        } else if (si == 6) {
          var _list4 = form.blower_fee_plan;
          for (var i in _list4) {
            var _plan5 = _list4[i];
            params["rent_blower_unit_minute_".concat(_plan5.value)] = _plan5.rent_blower_unit_minute;
            params["rent_blower_unit_fee_".concat(_plan5.value)] = _plan5.rent_blower_unit_fee;
            params["rent_blower_unit_show_".concat(_plan5.value)] = _plan5.rent_blower_unit_show;
          }
        } else if (si == 7) {
          var _list5 = form.condom_fee_plan;
          for (var i in _list5) {
            var _plan6 = _list5[i];
            params["condom_rent_unit_hour_".concat(_plan6.value)] = _plan6.rent_unit_hour;
            params["condom_rent_unit_fee_".concat(_plan6.value)] = _plan6.rent_unit_fee;
            params["condom_rent_unit_show_".concat(_plan6.value)] = _plan6.rent_unit_show;
          }
        }
        var goods_key_fee = fee_xcx[goods_key[si]] || fee_xcx.default;
        for (var key in goods_key_fee) {
          if (form["".concat(goods_key[si], "_fund_fee_plan").concat(key)]) {
            params["".concat(goods_key[si], "_fund_fee_plan").concat(key)] = form["".concat(goods_key[si], "_fund_fee_plan").concat(key)];
          }
          if (form["".concat(goods_key[si], "_fee_plan").concat(key)]) {
            params["".concat(goods_key[si], "_fee_plan").concat(key)] = form["".concat(goods_key[si], "_fee_plan").concat(key)];
          }
          if (key && form.business_mode["std_".concat(goods_key[si]).concat(key)]) {
            params["".concat(goods_key[si], "_business_mode").concat(key)] = form.business_mode["std_".concat(goods_key[si]).concat(key)];
          }
        }
        if (form.business_mode["std_".concat(goods_key[si])] && !fee_xcx[goods_key[si]]) {
          params["".concat(goods_key[si], "_business_mode_type")] = form.business_mode["std_".concat(goods_key[si])].business_mode_type;
          params["".concat(goods_key[si], "_pay_type")] = form.business_mode["std_".concat(goods_key[si])].pay_type;
          params["".concat(goods_key[si], "_advance_price")] = form.business_mode["std_".concat(goods_key[si])].advance_price;
          params["".concat(goods_key[si], "_order_type")] = form.business_mode["std_".concat(goods_key[si])].order_type;
        }
      }
      params.type = this.selType;
      params.store_id = id || this.id;
      params.zhuang_high_power = form.zhuang_high_power;

      // 获取最后一个套餐的 rent_zhuang_unit_power_max 作为 zhuang_power_max
      var zhuangPowerMax = 0;
      var businessModeType = form.business_mode.std_zhuang.business_mode_type;
      if (businessModeType == 1 && form.zhuang_fee_plan && form.zhuang_fee_plan.plan) {
        var planArray = Object.values(form.zhuang_fee_plan.plan);
        if (planArray.length > 0) {
          planArray.sort(function (a, b) {
            return parseInt(b.value) - parseInt(a.value);
          });
          zhuangPowerMax = planArray[0].rent_zhuang_unit_power_max || 0;
        }
      } else if (businessModeType == 2 && form.zhuang_electrcity_plan && form.zhuang_electrcity_plan.plan) {
        var serviceArray = Object.values(form.zhuang_electrcity_plan.plan);
        if (serviceArray.length > 0) {
          serviceArray.sort(function (a, b) {
            return parseInt(b.value) - parseInt(a.value);
          });
          zhuangPowerMax = serviceArray[0].rent_zhuang_unit_power_max || 0;
        }
      }
      params.zhuang_power_max = zhuangPowerMax;
      delete params.rent_zhuang_unit_hour;
      this.$post(url, params).then(function (res) {
        _this7.$message({
          message: '提交成功',
          type: 'success'
        });
        if (_this7.checkRoles(['partner'])) {
          console.log('admin_id:' + _this7.withdrawFeeObj.admin_id);
          _this7.$post('agentapi/setAdminWithdrawConfig', {
            'admin_id': _this7.withdrawFeeObj.admin_id,
            'id': _this7.withdrawFeeObj.id,
            'config_mode': _this7.withdrawFeeObj.config_mode,
            'withdraw_rate': _this7.withdrawFeeObj.withdraw_rate,
            'withdraw_amount': _this7.withdrawFeeObj.withdraw_amount
          }).then(function (res) {});
        }
        _this7.$router.push({
          path: '/shop/index'
        });
      }).catch(function (err) {
        _this7.update_fee_error = true;
        setTimeout(function () {
          _this7.clickSubmit = false;
        }, 1000);
      });
    },
    /**
     * 设置设备计费默认值
     */
    setDefaultPercent: function setDefaultPercent(percent) {
      this.form = Object.assign({}, this.form, percent);
    },
    /**
     * 上传文件成功通知
     */
    fileOk: function fileOk(arr) {
      this.form.avatar = arr[0] || '';
    },
    /**
       * 商户经纬度
       */
    locationOk: function locationOk(center) {
      this.form.latitude = center.lat;
      this.form.longitude = center.lng;
      // this.form.address = center.keyword
    },
    /**
     * 计算真实分成比例
     */
    countPercent: function countPercent(value, k) {
      var form = this.form;
      value = parseFloat(value);
      if (!value || value > 100 || value < 0) {
        this.$message({
          message: '分成数值须在0-100之间',
          type: 'error'
        });
        return;
      }
      var v = value * this.powerInfo["".concat(k, "_percent")] / 100;
      if (k == 'bao') v = value * parseFloat(this.powerInfo.percent) / 100;
      this.$set(this.form, "".concat(k, "_percent"), v.toFixed(2));
    },
    /**
     * 输入最大功率
     */
    setPowerMax: function setPowerMax(item) {
      var n = parseInt(item.value) + 1;
      this.form.zhuang_fee_plan.plan[n].rent_zhuang_unit_power_min = parseInt(item.rent_zhuang_unit_power_max) + 1;
    },
    setServicePowerMax: function setServicePowerMax(item) {
      var n = parseInt(item.value) + 1;
      this.form.zhuang_electrcity_plan.plan[n].rent_zhuang_unit_power_min = parseInt(item.rent_zhuang_unit_power_max) + 1;
    },
    /**
     * 检测套餐是否隐藏了几个，限制不能全部隐藏
     * @param {Object} arr
     * @param {Object} item
     */
    checkFeeShow: function checkFeeShow(arr, item) {
      var key = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'is_show';
      var feeShowNum = 0,
        v = item[key] == 0 ? 1 : 0;
      arr.map(function (i) {
        if (i[key] == 1) feeShowNum++;
      });
      if (feeShowNum < 5 && v == 0) {
        this.$message({
          message: '最少显示4个套餐',
          type: 'error'
        });
      } else {
        return item[key] = v;
      }
    },
    addZhuangPower: function addZhuangPower() {
      var fee_plan = this.form.zhuang_fee_plan.plan;
      var currentLength = Object.keys(fee_plan).length;
      if (currentLength >= 10) {
        this.$message({
          message: '最多显示10个套餐',
          type: 'error'
        });
        return;
      }
      var tempPower = fee_plan[currentLength].rent_zhuang_unit_power_max;
      if (this.form.zhuang_high_power == 1) {
        tempPower = tempPower + 2 >= 3500 ? 3498 : tempPower;
      } else {
        tempPower = tempPower + 2 >= 1500 ? 1498 : tempPower;
      }
      var obj2 = (0, _defineProperty2.default)({}, currentLength + 1, {
        "value": (currentLength + 1).toString(),
        "rent_zhuang_unit_fee": "10",
        "rent_zhuang_unit_power_min": tempPower + 1,
        "rent_zhuang_unit_power_max": tempPower + 2
      });
      fee_plan = Object.assign({}, fee_plan, obj2);
      this.form.zhuang_fee_plan.plan = Object.assign({}, this.form.zhuang_fee_plan.plan, fee_plan);
    },
    addServiceZhuangPower: function addServiceZhuangPower() {
      var fee_plan = this.form.zhuang_electrcity_plan.plan;
      var currentLength = Object.keys(fee_plan).length;
      if (currentLength >= 10) {
        this.$message({
          message: '最多显示10个套餐',
          type: 'error'
        });
        return;
      }
      var tempPower = fee_plan[currentLength].rent_zhuang_unit_power_max;
      if (this.form.zhuang_high_power == 1) {
        tempPower = tempPower + 2 >= 3500 ? 3498 : tempPower;
      } else {
        tempPower = tempPower + 2 >= 1500 ? 1498 : tempPower;
      }
      var obj2 = (0, _defineProperty2.default)({}, currentLength + 1, {
        "value": (currentLength + 1).toString(),
        "rent_zhuang_unit_fee": "10",
        "rent_zhuang_unit_power_min": tempPower + 1,
        "rent_zhuang_unit_power_max": tempPower + 2
      });
      fee_plan = Object.assign({}, fee_plan, obj2);
      this.form.zhuang_electrcity_plan.plan = Object.assign({}, this.form.zhuang_electrcity_plan.plan, fee_plan);
    },
    delZhuangPower: function delZhuangPower(index) {
      var fee_plan = this.form.zhuang_fee_plan.plan;
      //获取对象的长度
      var length = Object.keys(fee_plan).length;
      //请先删除最后一个
      if (index < length) {
        this.$message({
          message: '请先删除最后一个',
          type: 'error'
        });
        return;
      }
      delete fee_plan[index];
      this.form.zhuang_fee_plan.plan = Object.assign({}, fee_plan);
    },
    delServiceZhuangPower: function delServiceZhuangPower(index) {
      var fee_plan = this.form.zhuang_electrcity_plan.plan;
      //获取对象的长度
      var length = Object.keys(fee_plan).length;
      //请先删除最后一个
      if (index < length) {
        this.$message({
          message: '请先删除最后一个',
          type: 'error'
        });
        return;
      }
      delete fee_plan[index];
      this.form.zhuang_electrcity_plan.plan = Object.assign({}, fee_plan);
    },
    addZhuangHour: function addZhuangHour() {
      var fee_plan = this.form.zhuang_hourfeeplan;
      if (fee_plan.length >= 10) {
        this.$message({
          message: '最多显示10个套餐',
          type: 'error'
        });
        return;
      }
      var newItem = {
        "value": fee_plan.length + 1,
        "rent_zhuang_unit_hour": 1,
        "rent_zhuang_unit_fee": 1,
        "rent_zhuang_unit_show": 1
      };
      this.form.zhuang_hourfeeplan.push(newItem);
    },
    delZhuangHour: function delZhuangHour(index) {
      var fee_plan = this.form.zhuang_hourfeeplan;
      if (fee_plan.length <= 4) {
        this.$message({
          message: '最少显示4个套餐',
          type: 'error'
        });
        return;
      }
      this.form.zhuang_hourfeeplan.splice(index, 4);
    },
    addZhuangMin: function addZhuangMin() {
      var fee_plan = this.form.zhuang_minfeeplan;
      if (fee_plan.length >= 10) {
        this.$message({
          message: '最多显示10个套餐',
          type: 'error'
        });
        return;
      }
      var newItem = {
        "value": fee_plan.length + 1,
        "rent_zhuang_unit_min": 1,
        "rent_zhuang_unit_fee": 1,
        "rent_zhuang_unit_show": 1
      };
      this.form.zhuang_minfeeplan.push(newItem);
    },
    delZhuangMin: function delZhuangMin(index) {
      var fee_plan = this.form.zhuang_minfeeplan;
      if (fee_plan.length <= 4) {
        this.$message({
          message: '最少显示4个套餐',
          type: 'error'
        });
        return;
      }
      this.form.zhuang_minfeeplan.splice(index, 4);
    }
  }
};